import { render, staticRenderFns } from "./AssetAssignment.vue?vue&type=template&id=15e2e9aa&"
import script from "./AssetAssignment.vue?vue&type=script&lang=ts&"
export * from "./AssetAssignment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports